<template>
    <v-calendar
            ref="calendar"
            locale="es-es"
            v-model="model"
            v-on:change="onWeekChange"
            color="primary"
            :weekdays="weekDays || [1,2,3,4,5,6,0]"
            :interval-style="intervalStyle"
            :interval-minutes="intervalMinutes || 60"
            :first-interval="calculatedFirstInterval"
            :interval-count="intervalCount || 13"
            :type="type || ($vuetify.breakpoint.smAndDown ? '4day' : 'week')"
    >

        <template v-slot:day-header="{ date, day }">
            <div class="ml-2 interval-block" v-if="day === 1"> {{$moment(date).format('MMM')}}</div>
        </template>

        <template v-slot:interval="data">
            <div
                :class="['interval-block', {'hovered': isHoveredBlock(data)}]"
                @mouseup="onIntervalClicked($event, data)"
                @mousemove="onMouseEnterTime(data)"
            >
                <slot name="interval-block" :time="data.time"></slot>
            </div>
        </template>

        <template v-slot:day-body="{ date, timeToY, minutesToPixels }">
            <template v-for="(event, index) in eventsMap[date]">
                <slot
                  :index="index"
                  name="event"
                  :event="event"
                  :date="date"
                  :timeToY="timeToY"
                  :minutesToPixels="minutesToPixels">
                </slot>
            </template>
        </template>

    </v-calendar>
</template>

<script>

    export default{
        props: ['weekDays', 'intervalMinutes', 'firstInterval', 'intervalCount', 'value', 'events', 'capturing', 'type'],
        data(){
            return {
                model: this.value || this.$moment().format('YYYY-MM-DD'),
                highlightColor: 'rgba(0,0,0,0)',
                mouseEnterTime: {
                    hour: 0,
                    minute: 0,
                    day: 0,
                }
            }
        },
        methods:{
            getEventsMap(filter = (item) => item){

                var events = this.events.filter(filter)

                const map = {}
                events.forEach((e, index) => {
                    e.index = index
                    return (map[e.date] = map[e.date] || []).push(e)
                })

                return JSON.parse(JSON.stringify(map))

            },
            prev(){
                this.$refs.calendar.prev()
            },
            next(){
                this.$refs.calendar.next()
            },
            setDate(date){
                this.model= date
            },
            onIntervalClicked(evt, data) {
                var vm = this
                console.log('interval clicked data: ', data)
                data.event = vm.getEventFromData(data)
                vm.$emit('click-interval', evt, data)
            },
            isHoveredBlock({hour,minute,day}){
                var current = this.mouseEnterTime
                return current.day === day &&
                        current.hour === hour &&
                        current.minute === minute
            },
            onMouseDownTime(data){
                var vm = this
                if(vm.capturing){
                  data.event = vm.getEventFromData(data)
                  vm.$emit('capture-interval', data)
                }
            },
            onMouseEnterTime(data){

                var vm = this
                const {hour, minute, day} = data

                vm.mouseEnterTime= {
                    hour: hour,
                    minute: minute,
                    day: day,
                }

                if(vm.capturing){
                    data.event = vm.getEventFromData(data)
                    vm.$emit('capture-interval', data)
                }

            },
            onWeekChange(dates){
                this.$emit('week-change', dates)
            },
            getEventFromData(data){
                var vm = this
                var dayEvents = vm.eventsMap[data.date]
                var event = dayEvents && Object.keys(dayEvents).length ?
                        (dayEvents.find(event => event.time === data.time)  || null) : null

                return event

            },
            intervalStyle(interval){
                var vm = this
                return {
                    backgroundColor: (interval.hour == vm.mouseEnterTime.hour && interval.minute == vm.mouseEnterTime.minute) ||
                    interval.day == vm.mouseEnterTime.day   ?
                            vm.highlightColor : (interval.past ? ('rgba(0,0,0,0.05)') : undefined),
                    /*  borderTop: '1px dashed '*/
                }
            },
        },
        computed: {
            calculatedFirstInterval(){

                var vm = this
                if(!vm.firstInterval) return 8

                const minutes = vm.intervalMinutes || 60
                var willStartAt = 0;
                var dayStart = vm.$moment('00:00', 'HH:mm')
                const firstInterval = vm.$moment(vm.firstInterval, 'HH:mm')

                while(dayStart.isBefore(firstInterval)){
                    willStartAt++
                    dayStart.add(minutes, 'minutes')
                }

                return willStartAt


            },
            eventsMap () {
                const map = {}
                this.events.forEach((e, index) => {

                    e.index = index
                    return (map[e.date] = map[e.date] || []).push(e)

                })
                return map
            }
        },
        watch: {
            model(val){
              this.$emit('change', val)
            },
            value(val){
                this.model = val
            }
        }
    }
</script>

<style scoped>

    .interval-block{
        cursor: pointer;
        height: 40px;
        transition: .3s all;
        z-index: 9999
    }

    .interval-block.hovered{
        background-color: var(--v-accent-lighten2);
        color: #ffffff;
        border-radius: 5px;
        box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
    }


</style>
